import { Tooltip, useMediaQuery } from '@mui/material';
import { StyledToggleButton, StyledToggleButtonGroup, ToggleIndicator } from './style';
import { useAppDispatch, useAppSelector } from 'app/store';
import { selectLanguage, setLanguage } from 'app/store/userProfileSlice';
import { useTranslation } from 'react-i18next';
import theme from 'app/theme';

function LanguageSwitcher() {
  const dispatch = useAppDispatch();
  const language = useAppSelector(selectLanguage);
  const { i18n } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleLanguage = () => {
    const newLang = language === 'en' ? 'es' : 'en';
    dispatch(setLanguage(newLang));
    i18n.changeLanguage(newLang);
  };

  const englishWord = isMobile ? 'EN' : 'English';
  const spanishWord = isMobile ? 'ES' : 'Español';

  return (
    <Tooltip title={language === 'en' ? 'Cambiar a Español' : 'Change to English'} arrow>
      <StyledToggleButtonGroup
        value={language}
        exclusive
        onClick={handleLanguage}
        size="small"
        color="primary"
      >
        <StyledToggleButton value="en" size="small" disableRipple>
          {englishWord}
        </StyledToggleButton>

        <StyledToggleButton value="es" size="small" disableRipple>
          {spanishWord}
        </StyledToggleButton>

        <ToggleIndicator style={{ left: language === 'es' ? 'calc(50% - 6px)' : -6 }}>
          {language === 'es' ? spanishWord : englishWord}
        </ToggleIndicator>
      </StyledToggleButtonGroup>
    </Tooltip>
  );
}

export default LanguageSwitcher;
